var render, staticRenderFns
import script from "./comp_Footer-Newsletter.vue?vue&type=script&lang=js&"
export * from "./comp_Footer-Newsletter.vue?vue&type=script&lang=js&"
import style0 from "./comp_Footer-Newsletter.vue?vue&type=style&index=0&id=a551030a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a551030a",
  null
  
)

export default component.exports